/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { FormulaCalculationResponse } from '../models';
// @ts-ignore
import type { VehicleFleetConsumptionRequest } from '../models';
// @ts-ignore
import type { VehicleFleetDistanceRequest } from '../models';
/**
 * CalculationServiceVehicleFleetApi - axios parameter creator
 */
export const CalculationServiceVehicleFleetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate vehicle fleet emissions using consumption data
         * @param {VehicleFleetConsumptionRequest} vehicleFleetConsumptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehicleFleetConsumption: async (vehicleFleetConsumptionRequest: VehicleFleetConsumptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleFleetConsumptionRequest' is not null or undefined
            assertParamExists('vehicleFleetConsumption', 'vehicleFleetConsumptionRequest', vehicleFleetConsumptionRequest)
            const localVarPath = `/calculation/v1/calculate/vehicle-fleet/consumption`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleFleetConsumptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate vehicle fleet emissions using distance data
         * @param {VehicleFleetDistanceRequest} vehicleFleetDistanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehicleFleetDistance: async (vehicleFleetDistanceRequest: VehicleFleetDistanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleFleetDistanceRequest' is not null or undefined
            assertParamExists('vehicleFleetDistance', 'vehicleFleetDistanceRequest', vehicleFleetDistanceRequest)
            const localVarPath = `/calculation/v1/calculate/vehicle-fleet/distance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleFleetDistanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServiceVehicleFleetApi - functional programming interface
 */
export const CalculationServiceVehicleFleetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServiceVehicleFleetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate vehicle fleet emissions using consumption data
         * @param {VehicleFleetConsumptionRequest} vehicleFleetConsumptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehicleFleetConsumption(vehicleFleetConsumptionRequest: VehicleFleetConsumptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehicleFleetConsumption(vehicleFleetConsumptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceVehicleFleetApi.vehicleFleetConsumption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Calculate vehicle fleet emissions using distance data
         * @param {VehicleFleetDistanceRequest} vehicleFleetDistanceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehicleFleetDistance(vehicleFleetDistanceRequest: VehicleFleetDistanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormulaCalculationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehicleFleetDistance(vehicleFleetDistanceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceVehicleFleetApi.vehicleFleetDistance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServiceVehicleFleetApi - factory interface
 */
export const CalculationServiceVehicleFleetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServiceVehicleFleetApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate vehicle fleet emissions using consumption data
         * @param {CalculationServiceVehicleFleetApiVehicleFleetConsumptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehicleFleetConsumption(requestParameters: CalculationServiceVehicleFleetApiVehicleFleetConsumptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.vehicleFleetConsumption(requestParameters.vehicleFleetConsumptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate vehicle fleet emissions using distance data
         * @param {CalculationServiceVehicleFleetApiVehicleFleetDistanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehicleFleetDistance(requestParameters: CalculationServiceVehicleFleetApiVehicleFleetDistanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<FormulaCalculationResponse> {
            return localVarFp.vehicleFleetDistance(requestParameters.vehicleFleetDistanceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for vehicleFleetConsumption operation in CalculationServiceVehicleFleetApi.
 */
export interface CalculationServiceVehicleFleetApiVehicleFleetConsumptionRequest {
    readonly vehicleFleetConsumptionRequest: VehicleFleetConsumptionRequest
}

/**
 * Request parameters for vehicleFleetDistance operation in CalculationServiceVehicleFleetApi.
 */
export interface CalculationServiceVehicleFleetApiVehicleFleetDistanceRequest {
    readonly vehicleFleetDistanceRequest: VehicleFleetDistanceRequest
}

/**
 * CalculationServiceVehicleFleetApi - object-oriented interface
 */
export class CalculationServiceVehicleFleetApi extends BaseAPI {
    /**
     * 
     * @summary Calculate vehicle fleet emissions using consumption data
     * @param {CalculationServiceVehicleFleetApiVehicleFleetConsumptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public vehicleFleetConsumption(requestParameters: CalculationServiceVehicleFleetApiVehicleFleetConsumptionRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceVehicleFleetApiFp(this.configuration).vehicleFleetConsumption(requestParameters.vehicleFleetConsumptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate vehicle fleet emissions using distance data
     * @param {CalculationServiceVehicleFleetApiVehicleFleetDistanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public vehicleFleetDistance(requestParameters: CalculationServiceVehicleFleetApiVehicleFleetDistanceRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceVehicleFleetApiFp(this.configuration).vehicleFleetDistance(requestParameters.vehicleFleetDistanceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

